(() => {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  const tag = 'lrs-editorial-application';
  if (customElements.get(tag)) return;

  class LRSEditorialApplication extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const form = this.querySelector('form');
      if (!form) return;
      form.setAttribute('data-editorial-application-form', '');
      const submit = form.querySelector('[data-editorial-submit]');
      const submitLabel = form.querySelector('[data-editorial-submit-label]');
      const originalLabel = submitLabel?.textContent || '';
      const photos = form.querySelector('[data-editorial-photos]');
      const story = form.querySelector('[data-editorial-story]');
      const count = form.querySelector('[data-editorial-count]');
      let resetTimer;
      let pendingTimer;

      const resetPending = () => {
        clearTimeout(pendingTimer);
        clearTimeout(resetTimer);
        form.removeAttribute('aria-busy');
        if (submit) submit.disabled = false;
        if (submitLabel) submitLabel.textContent = originalLabel;
      };
      this.resetPending = resetPending;

      const validatePhotoLink = () => {
        if (!photos) return;
        const value = photos.value.trim();
        let valid = true;
        if (value) {
          try {
            const url = new URL(value);
            valid = ['https:', 'http:'].includes(url.protocol) && Boolean(url.hostname);
          } catch (_) {
            valid = false;
          }
        }
        photos.setCustomValidity(valid ? '' : t(photos.dataset.urlMessage || 'Please use a complete https:// or http:// link.'));
      };

      const updateCount = () => {
        if (!story || !count) return;
        count.hidden = false;
        count.textContent = `${story.value.length.toLocaleString()} / ${story.maxLength.toLocaleString()}`;
      };

      form.addEventListener('input', (event) => {
        if (event.target === photos) validatePhotoLink();
        if (event.target === story) updateCount();
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
          if (event.target.validity.valid) event.target.removeAttribute('aria-invalid');
        }
      }, { signal });

      form.addEventListener('invalid', (event) => {
        event.target.setAttribute('aria-invalid', 'true');
        resetPending();
      }, { capture: true, signal });

      form.addEventListener('submit', (event) => {
        validatePhotoLink();
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        // Native Shopify sends the application. Its Liquid response owns success.
        // Wait until other handlers (including captcha / preview) can cancel POST.
        clearTimeout(pendingTimer);
        pendingTimer = setTimeout(() => {
          pendingTimer = undefined;
          if (event.defaultPrevented || !this.isConnected) return;
          form.setAttribute('aria-busy', 'true');
          if (submit) submit.disabled = true;
          if (submitLabel) submitLabel.textContent = t(submit?.dataset.pendingLabel || originalLabel);
          resetTimer = setTimeout(resetPending, 12000);
        }, 0);
      }, { signal });

      window.addEventListener('pageshow', resetPending, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') resetPending();
      }, { signal });
      validatePhotoLink();
      updateCount();

      const response = this.querySelector('[data-editorial-errors], [data-editorial-success]');
      if (response && !window.Shopify?.designMode && !window.LRSPreview) {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          response.focus({ preventScroll: true });
          this.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      }
    }

    disconnectedCallback() {
      this.resetPending?.();
      this.controller?.abort();
      this.controller = null;
      this.resetPending = null;
    }
  }

  customElements.define(tag, LRSEditorialApplication);
})();
